import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "components/dialog";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Input from "../bannerInput";
import Button from "../button";
import ForgotPassword from "../forgot-Password";
import VerifyCode from "../verifyCode";
import "./style.css";

import { Formik } from "formik";
import * as Yup from "yup";

import { login } from "api/Auth";
import {
  getUserFromLocalStorage,
  storeUserInLocalStorage,
} from "hooks/LocalStorage";
import { useTranslation } from "i18n";
import { CurrencyContext } from "pages/useContext";

const Login = ({ handelOpenSignUp }) => {
  const { t } = useTranslation();
  const [openLogin, setOpenLogin] = useState(false);

  const { hash } = useLocation();

  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [forgotPass, setForgotPass] = useState(false);
  const { setCurrency } = useContext(CurrencyContext);

  const emailValidator = Yup.string().email().required().label(t("account.email"));

  const validationSchema = Yup.object().shape({
    email: emailValidator,
    password: Yup.string().min(3).required().label(t("auth.password")),
  });

  const handleCloseLoginModal = () => {
    window.location.hash = "";

    setForgotPass(false);
  };

  const handelSubmit = async (values) => {
    setLoading(true);
    setErr("");
    const res = await login({ body: values });

    if (!res.ok) {
      setErr(res?.data?.errorDetails);
      if (res?.status === 403) {
        setShowOtp(true);
        setEmail(values.email);
      }
    } else {
      handleCloseLoginModal();

      const token = {
        authenticationToken: res?.data?.authenticationToken,
        refreshToken: res?.data?.refreshToken,
      };

      storeUserInLocalStorage(token);

      const getTokenData = getUserFromLocalStorage();

      window.dispatchEvent(new Event("storage"));

      //*********** Store currency in Local Storage ************//

      // setCurrency({
      //   tokenCurrency: getTokenData?.registeredFrom,
      // });
      // navigate(0);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (hash === "#auth-required") {
      setOpenLogin(true);
    } else {
      setOpenLogin(false);
    }
  }, [hash]);

  return (
    <Dialog open={openLogin} onClose={handleCloseLoginModal} padded={false}>
      {forgotPass ? (
        <ForgotPassword setForgotPass={setForgotPass} />
      ) : !showOtp ? (
        <div className="login-modal">
          <div className="login-modal__glow" />
          <p className="login-modal__brand">{t("home.appBrand")}</p>
          <h1 className="login-modal__title">{t("auth.loginTitle")}</h1>
          <p className="login-modal__subtitle">{t("auth.loginSubtitle")}</p>
          {err && (
            <Alert severity="error" sx={{ mb: 2, borderRadius: "14px" }}>
              {err}
            </Alert>
          )}
          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            validationSchema={validationSchema}
            onSubmit={handelSubmit}
          >
            {({
              handleChange,
              handleSubmit,
              errors,
              setFieldTouched,
              touched,
              values,
              setFieldValue,
            }) => (
              <>
                <Input
                  onChange={(e) => {
                    const value = e.target.value || "";
                    setFieldValue("email", value.toLowerCase());
                  }}
                  error={touched.email && errors.email}
                  onBlur={() => setFieldTouched("email")}
                  name={"email"}
                  mandatory={true}
                  type="email"
                  label={t("auth.enterEmail")}
                />
                <Input
                  onChange={handleChange(`password`)}
                  error={touched.password && errors.password}
                  onBlur={() => setFieldTouched("password")}
                  name={"password"}
                  mandatory={true}
                  type="password"
                  label={t("auth.enterPassword")}
                />
                <div className="login-modal__forgot">
                  <button
                    type="button"
                    className="login-modal__link"
                    onClick={() => {
                      setForgotPass(true);
                      setEmail("");
                    }}
                  >
                    {t("auth.forgotPasswordQuestion")}
                  </button>
                </div>

                <Button
                  type="submit"
                  onClick={handleSubmit}
                  className="bigBtn w-100 primary-color"
                >
                  {loading ? (
                    <CircularProgress sx={{ color: "#fff" }} size={22} />
                  ) : (
                    t("navigation.logIn")
                  )}
                </Button>
              </>
            )}
          </Formik>
          <p className="login-modal__footer">
            {t("auth.noAccount")}{" "}
            <button
              type="button"
              className="login-modal__link"
              onClick={handelOpenSignUp}
            >
              {t("navigation.signUp")}
            </button>
          </p>
        </div>
      ) : (
        <VerifyCode email={email} handleClose={handleCloseLoginModal} />
      )}
    </Dialog>
  );
};

export default Login;
